function makeUrl(url) {
    return encodeURIComponent(url);
}

export default makeUrl;
